import { useQuery } from '@tanstack/react-query';
import { diagnosticService } from '../services';

export function useDiagnosticTrend(days = 30) {
  return useQuery({
    queryKey: ['diagnostic', 'trend', days],
    queryFn: () => diagnosticService.getTrend(days),
    staleTime: 5 * 60 * 1000,
  });
}
